import { Injectable } from '@angular/core';
import {ApiService} from "../../../services/external-api/api.service";
import {IApplicationParametersState} from "../state/application-parameters/application-parameters.state";
import {ConfigurationManager} from "../../configuration-manager/configuration-manager";

@Injectable({
  providedIn: 'root'
})
export class OsaService {

  constructor(private apiService: ApiService, private configurationManager: ConfigurationManager) { }

  getScannings(accessToken: string, param: IApplicationParametersState){
    return this.apiService.get(this.configurationManager.getApiUrl('apiOSAUrl') + '/processings/scanings', {
      'access_token':accessToken,
      'date_from': param.selectedDateFrom, //'20010101',
      'date_until':param.selectedDateTo // '20991231'
    });
  }

}
